import cx from 'classnames';
import styles from './RadioGroup.module.scss';
import usePresenter from './RadioGroup.presenter';
import type { RadioGroupProps } from './RadioGroup.types';

const RadioGroup = (props: RadioGroupProps) => {
  const {
    orientation = 'vertical',
    radioButtons,
    variantProps,
  } = usePresenter(props);

  return (
    <div
      className={cx(styles.radioGroup, {
        [styles[orientation]]: orientation,
      }, props.className)}
      role="radiogroup"
      {...variantProps}
    >
      {radioButtons}
    </div>
  );
};

export default RadioGroup; 